export default __webpack_public_path__ + "static/media/brazil.d5d82bec.png";